import { render, staticRenderFns } from "./InviteHousematesView.vue?vue&type=template&id=98b8ec42&scoped=true&"
import script from "./InviteHousematesView.vue?vue&type=script&lang=ts&"
export * from "./InviteHousematesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b8ec42",
  null
  
)

export default component.exports